import * as React from 'react';
export var ITrackType;
(function (ITrackType) {
    ITrackType["PAGE_VIEW"] = "pageView";
    ITrackType["EVENT"] = "event";
    ITrackType["TIMING"] = "timing";
})(ITrackType || (ITrackType = {}));
var noop = function () { };
// Default values that can be overridden by the value of clickstreamAnalytics prop of <ClickstreamAnalyticsProvider>
var DEFAULTS = {
    track: noop,
    reset: noop
};
var Context = React.createContext(DEFAULTS);
/**
 * Provider component for supplying analytics functions to your React tree.
 */
export var ClickstreamAnalyticsProvider = function (props) {
    var clickstreamAnalytics = props.clickstreamAnalytics, children = props.children;
    return React.createElement(Context.Provider, { value: clickstreamAnalytics }, children);
};
ClickstreamAnalyticsProvider.displayName = 'ClickstreamAnalyticsProvider';
export var useClickstreamAnalytics = function () { return React.useContext(Context); };
//# sourceMappingURL=clickstream-analytics-context.js.map